import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { Category } from '../../interfaces/Category/Category';
import { getCategories } from '../../api/Category';

interface CategorySlugsDropdownProps {
  label?: string;
  categorySlugs: string[];
  onChange: (slugs: string[]) => void;
  disabled?: boolean;
}

export const CategorySlugsDropdown = (props: CategorySlugsDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    setLoading(true);
    getCategories()
      .then((c) => setCategories(c))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Autocomplete
        multiple
        disableCloseOnSelect
        limitTags={2}
        size='small'
        disabled={props.disabled}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant='outlined'
            fullWidth
          />
        )}
        options={categories}
        getOptionLabel={(category) => category.name}
        onChange={(_, selectedCategories) =>
          props.onChange(selectedCategories.map((category) => category.slug))
        }
        value={categories.filter((category) =>
          props.categorySlugs.includes(category.slug),
        )}
      />
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
